import { getWindowSafe } from '@change-corgi/core/window';

export function isSsr(): boolean {
	return typeof getWindowSafe() === 'undefined';
}
